import { useCallback, useMemo } from 'react';

import { useAuth } from '../contexts/AuthContext';
import { isPlatformSuperAdmin } from '../utils/authAccess';
import {
  userHasAnyOrgPermission,
  userHasOrgPermission,
  usesOrganizationPermissions,
} from '../utils/orgPermissionAccess';

/**
 * مجوزهای سازمان فعال برای گیت UI صفحات tenant.
 */
export function useOrgPermissions() {
  const { user } = useAuth();

  const can = useCallback(
    (permission) => userHasOrgPermission(user, permission),
    [user],
  );

  const canAny = useCallback(
    (permissions) => userHasAnyOrgPermission(user, permissions),
    [user],
  );

  const isTenant = usesOrganizationPermissions(user);
  const platformSuperAdmin = isPlatformSuperAdmin(user);

  return useMemo(
    () => ({
      user,
      can,
      canAny,
      isTenant,
      isPlatformSuperAdmin: platformSuperAdmin,
      canCreate: (resource) => can(`${resource}.create`),
      canUpdate: (resource) => can(`${resource}.update`),
      canDelete: (resource) => can(`${resource}.delete`),
      canView: (resource) => can(`${resource}.view`) || can(`${resource}.view-any`),
    }),
    [user, can, canAny, isTenant, platformSuperAdmin],
  );
}
